
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import image1 from "../img/tradly/Peer-to-peer-Fundraising-crowdfunding-platform-1024x970.png"
import image2 from "../img/tradly/Screen-Shot-2021-02-20-at-3.57.36-PM-1-599x1024.png"
import image3 from "../img/tradly/Screen-Shot-2021-02-20-at-3.57.55-PM-1-614x1024.png"
import image4 from "../img/tradly/Screen-Shot-2021-02-21-at-7.36.47-AM-2-1024x289.png"
import image5 from "../img/tradly/Screen-Shot-2021-02-21-at-7.32.40-AM-1024x377.png"
import Cta from '@/partials/Cta'
const Layout = require('@/layouts/RootFileLayout').RootFileLayout;
const meta = {
  "title": "Build and Launch a education marketplace like Coursera, Udemy, Wyzant",
  "date": "2021-02-22"
};
const slug = 'build-a-education-marketplace-like-coursera';
const tableOfContents = [{
  "title": "Education Marketplace",
  "slug": "education-marketplace",
  "children": []
}, {
  "title": "",
  "slug": "",
  "children": []
}, {
  "title": " Discussion thread like Udemy",
  "slug": "discussion-thread-like-udemy",
  "children": []
}, {
  "title": " like coursera and udemy",
  "slug": "like-coursera-and-udemy",
  "children": []
}, {
  "title": "",
  "slug": "-1",
  "children": []
}, {
  "title": "",
  "slug": "-2",
  "children": []
}, {
  "title": "Configure your listing aka courses like coursera",
  "slug": "configure-your-listing-aka-courses-like-coursera",
  "children": []
}];

const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = require('@/layouts/CustomContentsLayout').CustomContentsLayout
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <p><em parentName="p">{`Building an education marketplace like Coursera, Udemy, Wyzant?`}</em>{` is a tiresome and time-consuming task and will take months just to develop even the most fundamental features.`}</p>
    <p>{`While one can do that it’s really not very feasible for most. So what’s the solution? you might ask and Tradly Platform is the solution with `}<a parentName="p" {...{
        "href": "http://tradly.app/"
      }}>{`TradlyPlatform`}</a>{` one can create a platform like Coursera in a matter of days and with the necessary features.`}</p>
    <_Heading level={2} id={"education-marketplace"} nextElement={{
      "type": "paragraph"
    }}>Education Marketplace</_Heading>
    <p>{`Here’s a list of features that Tradly Platform gives you access to.`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">
        <p parentName="li">{`Wyzant is an online services marketplace in educational technology for matching tutors with students. `}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Udemy, Inc. is an American massive open online course provider aimed at professional adults and students`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://course.com/"
          }}>{`Coursera`}</a>{` is one of the biggest and most expansive education marketplace on the planet. Its easy to navigate through and the large number of courses make it an easy choice for universities and students all over the world.`}</p>
        <img src={image1} alt="" />
      </li>
    </ul>
    <_Heading level={2} id={""} nextElement={{
      "type": "jsx"
    }}></_Heading>
 <img src={image2} alt="" />
    
 <img src={image3} alt="" />
    
    <_Heading level={2} id={"discussion-thread-like-udemy"} nextElement={{
      "type": "heading",
      "depth": 2
    }}> Discussion thread like Udemy</_Heading>
    <_Heading level={2} id={"like-coursera-and-udemy"} nextElement={{
      "type": "jsx"
    }}> like coursera and udemy</_Heading>
 <img src={image4} alt="" />
    <_Heading level={2} id={"-1"} nextElement={{
      "type": "heading",
      "depth": 2
    }}></_Heading>
    <_Heading level={2} id={"-2"} nextElement={{
      "type": "heading",
      "depth": 2
    }}></_Heading>
    <_Heading level={2} id={"configure-your-listing-aka-courses-like-coursera"} nextElement={{
      "type": "jsx"
    }}>Configure your listing aka courses like coursera</_Heading>
 <img src={image5} alt="" />
    <Cta mdxType="Cta" />



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
